/**
 *
 * AdminView
 *
 */
import {
    Box,
    Button,
    CardMedia,
    Divider,
    Grid,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
    Typography
} from '@mui/material';
import { useEffect } from 'react';
import SubCard from 'ui-component/cards/SubCard';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import React from 'react';
import { toast } from 'react-toastify';
import { IconCopy } from '@tabler/icons';

interface Props {}

export default function QuestionnearDetail(props: any) {
    const { apiData } = props;

    const [copyValue, setCopyValue] = React.useState('');
    const [copied, setCopied] = React.useState(false);
    const getAdminData = () => {
        // dispatchLoader(true)
        // getAdmin({ uuid: uuid }).then((res: any) => {
        //   res = res?.map((item: any) => {
        //     item.user_type = item?.user_type == "SERVICEPROVIDER" ? "SERVICE PROVIDER" : item?.user_type
        //     return item
        //   })
        //   setApiData(res[0])
        //   dispatchLoader(false)
        // }).catch((err:any) => {
        //   dispatchLoader(false)
        // })
    };

    useEffect(() => {
        getAdminData();
    }, []);

    const notify = () =>
        toast.success('Url copied to clipboard successfully !', {
            position: 'bottom-left',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light'
        });

    const onCopy = React.useCallback((e: any) => {
        setCopied(true);
    }, []);

    const onClick = React.useCallback(({}) => {
        notify();
    }, []);
    const openInNewTab = (url: any) => {
        window.open(url, '_blank', 'noreferrer');
    };

    console.log('apiData', apiData);

    useEffect(() => {
        if (apiData?.questionnaire[0]?.additional_video) {
            setCopyValue(`${apiData?.questionnaire[0]?.additional_video}`);
        }
    }, [apiData]);

    return (
        <>
            {/* <CustomizedBreadCrumb title="Questionnear Details" /> */}
            <Grid container direction="column" spacing={2} style={{ marginTop: '30px' }}>
                <Grid item xs={12}>
                    <SubCard>
                        <div>
                            <SubCard sx={{ mb: 2 }}>
                                <Accordion>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                                        <Typography variant="subtitle1">
                                            Upload a short video explaining why you would like to be part of the Sephora Squad ?
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Grid container spacing={3}>
                                            <Grid item md={12} xs={12} sm={12}>
                                                <CardMedia
                                                    component="video"
                                                    style={{ width: '200px', height: '160px' }}
                                                    image={
                                                        apiData?.questionnaire[0]?.additional_video &&
                                                        apiData?.questionnaire[0]?.additional_video
                                                    }
                                                    controls={true}
                                                />
                                                <div style={{ marginTop: '5px' }}>
                                                    <CopyToClipboard text={copyValue} onCopy={onCopy}>
                                                        <IconCopy onClick={onClick} />
                                                    </CopyToClipboard>
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </AccordionDetails>
                                </Accordion>
                            </SubCard>
                            <SubCard sx={{ mb: 2 }}>
                                <Accordion>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                                        <Typography variant="subtitle1">
                                            In a few words, why do you want to join the Sephora squad?
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography fontSize={'18px'} variant="subtitle2">
                                            {apiData?.questionnaire[0]?.question_1}
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                            </SubCard>

                            <SubCard sx={{ mb: 2 }}>
                                <Accordion>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2a-content" id="panel2a-header">
                                        <Typography variant="subtitle1">
                                            Share Your Story, What Inspired You To Become A Beauty Content Creator? How Did Your Journey
                                            Begin?
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography fontSize={'18px'} variant="subtitle2">
                                            {apiData?.questionnaire[0]?.question_2}
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                            </SubCard>

                            <SubCard sx={{ mb: 2 }}>
                                <Accordion>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2a-content" id="panel2a-header">
                                        <Typography variant="subtitle1">How would you describe the content on your page</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography fontSize={'18px'} variant="subtitle2">
                                            {apiData?.questionnaire[0]?.question_3}
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                            </SubCard>

                            <SubCard sx={{ mb: 2 }}>
                                <Accordion>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2a-content" id="panel2a-header">
                                        <Typography variant="subtitle1">
                                            Name Your Favourite Beauty / Content Creator And Why?
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography fontSize={'18px'} variant="subtitle2">
                                            {apiData?.questionnaire[0]?.question_4}
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                            </SubCard>

                            <SubCard sx={{ mb: 2 }}>
                                <Accordion>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2a-content" id="panel2a-header">
                                        <Typography variant="subtitle1">
                                            What Do You Think You Will Add To The Sephora Squad?
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography fontSize={'18px'} variant="subtitle2">
                                            {apiData?.questionnaire[0]?.question_5}
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                            </SubCard>

                            <SubCard sx={{ mb: 2 }}>
                                <Accordion>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2a-content" id="panel2a-header">
                                        <Typography variant="subtitle1">
                                            What Does Sephora Mean To You?
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography fontSize={'18px'} variant="subtitle2">
                                            {apiData?.questionnaire[0]?.question_6}
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                            </SubCard>

                            <SubCard sx={{ mb: 2 }}>
                                <Accordion>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2a-content" id="panel2a-header">
                                        <Typography variant="subtitle1">
                                            What are your top 5 brands sold at Sephora & Why?
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography fontSize={'18px'} variant="subtitle2">
                                            {apiData?.questionnaire[0]?.question_7}
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                            </SubCard>

                            <SubCard sx={{ mb: 2 }}>
                                <Accordion>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2a-content" id="panel2a-header">
                                        <Typography variant="subtitle1">
                                            Where Did You Learn About The Sephora Squad Program From?
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography fontSize={'18px'} variant="subtitle2">
                                            {apiData?.questionnaire[0]?.question_8}
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                            </SubCard>

                            <SubCard sx={{ mb: 2 }}>
                                <Accordion>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2a-content" id="panel2a-header">
                                        <Typography variant="subtitle1">
                                            What's a beauty trend you're currently obsessed with?
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography fontSize={'18px'} variant="subtitle2">
                                            {apiData?.questionnaire[0]?.question_9}
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                            </SubCard>

                            <SubCard sx={{ mb: 2 }}>
                                <Accordion>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2a-content" id="panel2a-header">
                                        <Typography variant="subtitle1">
                                            Finish the sentence: "My followers come to me for…
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography fontSize={'18px'} variant="subtitle2">
                                            {apiData?.questionnaire[0]?.question_10}
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                            </SubCard>

                            <SubCard sx={{ mb: 2 }}>
                                <Accordion>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2a-content" id="panel2a-header">
                                        <Typography variant="subtitle1">
                                            What three beauty products can you not live without & Why
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography fontSize={'18px'} variant="subtitle2">
                                            {apiData?.questionnaire[0]?.question_11}
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                            </SubCard>

                            <SubCard sx={{ mb: 2 }}>
                                <Accordion>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2a-content" id="panel2a-header">
                                        <Typography variant="subtitle1">Are you part of the Sephora Loyalty program?</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography fontSize={'18px'} variant="subtitle2">
                                            {apiData?.questionnaire[0]?.is_loyalty ? 'Yes' : 'No'}
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                            </SubCard>
                        </div>
                    </SubCard>
                </Grid>
            </Grid>
        </>
    );
}
